/**
 * Analytics · Document Intelligence
 * Demo content - see src/demo/analytics.ts.
 */

import React from 'react';
import { AppShell } from '../../components/shell/AppShell';
import { Card, Kpi, PageHead, Table, Tag, Bar, Note, DemoBadge } from '../../components/ui';
import { ChartFrame, AreaTrend, Bars, STATUS } from '../../components/charts';
import { DOCS } from '../../demo/analytics';

export const DocumentIntelligencePage: React.FC = () => (
  <AppShell
    title="Document Intelligence"
    sub="Analytics"
    actions={
      <>
        <DemoBadge />
        <button className="btn btn-g">Extraction rules</button>
        <button className="btn btn-p">Upload documents</button>
      </>
    }
  >
    <PageHead
      eyebrow="Analytics"
      title="What the documents hold"
      lede="Contracts, board packs and spreadsheets are read into the same layer as the systems, with the fields extracted from each. A clause in a contract is as answerable as a row in the ERP."
    />

    <div className="g g4" style={{ marginBottom: 12 }}>
      {DOCS.kpis.map((k) => (
        <Kpi
          key={k.label}
          label={k.label}
          value={k.value}
          unit={'unit' in k ? (k as any).unit : undefined}
          color={k.color}
          icon={k.icon as any}
          pip={'pip' in k ? (k as any).pip : undefined}
          dir={('dir' in k ? (k as any).dir : '') as any}
          sub={'sub' in k ? (k as any).sub : undefined}
        />
      ))}
    </div>

    <div className="g g2" style={{ marginBottom: 12 }}>
      <ChartFrame title="Documents indexed" sub="per week">
        <AreaTrend data={DOCS.ingestion} x="week" series={[{ key: 'indexed', label: 'Indexed' }]} />
      </ChartFrame>

      <ChartFrame title="Library by type" sub="documents">
        <Bars data={DOCS.byType} x="type" horizontal series={[{ key: 'count', label: 'Documents' }]} />
      </ChartFrame>
    </div>

    <div className="g g3">
      <div className="s2">
        <Card title="Recently added" flush>
          <Table
            cols={[{ t: 'Document' }, { t: 'Type' }, { t: 'Pages', num: true }, { t: 'Added' }, { t: 'Status' }]}
            rows={DOCS.recent.map((d) => [
              <b className="mono" style={{ fontSize: 12 }}>
                {d.name}
              </b>,
              d.type,
              d.pages,
              <span className="dim">{d.added}</span>,
              <Tag tone={d.tone as any}>{d.status}</Tag>,
            ])}
          />
        </Card>
      </div>

      <Card title="Fields extracted" sub="coverage across contracts">
        {DOCS.extracted.map((f) => (
          <div className="prog-row" key={f.field}>
            <span className="l">{f.field}</span>
            <Bar
              pct={f.coverage}
              width="100%"
              color={f.coverage >= 70 ? STATUS.good : f.coverage >= 25 ? STATUS.warning : STATUS.serious}
            />
            <span className="v">{f.coverage}%</span>
          </div>
        ))}
        <Note style={{ marginTop: 10 }}>
          <b>Liability caps are only found in 19% of contracts.</b> Where a field is not extracted,
          OmniMind says so rather than treating absence as zero.
        </Note>
      </Card>
    </div>
  </AppShell>
);
